// extracted by mini-css-extract-plugin
module.exports = {"icon":"BriefActions_icon__3u1zg","trigger":"BriefActions_trigger__3Md6E"};